export default __webpack_public_path__ + "static/media/doctorlogin.d0c91ded.png";